export default __webpack_public_path__ + "static/media/pt.279b11fa.svg";